import { Input } from 'components/Form'
import { noop } from 'utils'
import { AdvancedInputProps } from '.'
import { BasicInputGroup } from './BasicInputGroup'

export interface EmailInputProps extends AdvancedInputProps {
  value?: string
}
export const EmailInput = ({
  name,
  label,
  placeholder = 'Enter email',
  value = '',
  setFieldValue,
  onBlur = noop,
  disabled,
  error,
  tabIndex,
  showShortcuts,
}: EmailInputProps) => {
  const handleEmailChange = (evt: any) => {
    const { name, value } = evt.target
    const processedValue = value.trim()
    setFieldValue(name, processedValue)
  }
  const displayText = value || '-'

  return (
    <BasicInputGroup
      name={name}
      label={label}
      disabled={disabled}
      display={displayText}
      error={error}
      copyableText={showShortcuts ? value : undefined}
      input={
        <Input
          id={name}
          name={name}
          placeholder={placeholder}
          onChange={handleEmailChange}
          onBlur={onBlur}
          value={value}
          aria-invalid={!!error}
          disabled={disabled}
          tabIndex={tabIndex}
        />
      }
    />
  )
}
